/**
 * there isn't enough going on in here to write unit tests for at this time
 */

import axios, { AxiosRequestConfig } from 'axios'

const config: AxiosRequestConfig = { withCredentials: true }

if (process.env.NODE_ENV === 'production')
  config.baseURL = `${process.env.REACT_APP_BACK_END_URL}`

/**
 * the axios instance needed to interface with `/api`
 */
export const rest = axios.create(config)
